import PropTypes from 'prop-types'
import React from "react"
import { Modal, ModalBody } from "reactstrap"
import i18n from "i18next"

const DeleteModal = ({ show, onDeleteClick, onCloseClick, entityName, errorMessage }) => {
  return (
    <Modal size="sm" isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button type="button" onClick={onCloseClick} className="btn-close position-absolute end-0 top-0 m-3"></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="mdi mdi-trash-can-outline"></i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">{i18n.t("DELETE_CONFIRM_MESSAGE") + entityName}?</p>

          <div className="hstack gap-2 justify-content-center mb-0">
            {!errorMessage && <button type="button" className="btn btn-danger" onClick={onDeleteClick}>{i18n.t("DELETE")}</button>}
            <button type="button" className="btn btn-secondary" onClick={onCloseClick}>{i18n.t("CLOSE")}</button>
          </div>
          {errorMessage && <div className="text-danger mt-2">{i18n.t("ERROR")} : {errorMessage}</div>}
        </ModalBody>
      </div>
    </Modal>
  )
}

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any
}

export default DeleteModal
